// extracted by mini-css-extract-plugin
export default {"p":"d27b2893a7 _224e05d616 _67dd779825","clr":"_6f1a05d949","dls":"_85f33f34b0"};